import { useState, useEffect } from "react";
import { AuthRequest } from "../../util/request/authRequest";
import { useNavigate } from "react-router-dom";

const AutoToPage = () => {
  const navigate = useNavigate();
  const [authResult, setAuthResult] = useState("waiting");

  useEffect(() => {
    async function verif() {
      const response = await AuthRequest({ subLink: "auth/verifyToken" });
      //   console.log(response.status);
      //   setAuthResult(response.status);
      //   try {
      //     const response = await AuthRequest({ subLink: "auth/verifyToken" });
      //   } catch (error) {
      //     console.log(error);
      //   }
      if (response.status == 401) {
        return navigate("/login");
      }
      if (response.status == 200) {
        return navigate("/adminDashboard");
      }
    }
    //   setAuthResult(response.data.status);

    verif();
  }, []);

  return (
    <>
      {/* {authResult == 401 && <></>} */}
      {/* {authResult == 200 && <OrderPage />} */}
    </>
  );
};

export default AutoToPage;
